import { Picker, PickerOption } from "./picker";
import GameSettingsLabel from "../game-settings-label/game-settings-label";

type Props = {
  label: string;
  subLabel?: string;

  options: PickerOption<number>[];

  value: number;
  onSelect: (val: number) => void;
  customPlaceholder?: string;
  disabled?: boolean;
};

const FullPicker: React.FunctionComponent<Props> = (props) => {
  return (
    <div
      className={`self-stretch py-0 flex flex-row justify-between items-center ${props.disabled ? "opacity-50 pointer-events-none" : ""}`}
    >
      <GameSettingsLabel label={props.label} subLabel={props.subLabel} />

      <div className="self-stretch w-1/3 h-full flex justify-center items-center">
        <Picker
          customPlaceholder={props.customPlaceholder}
          value={props.value}
          onSelect={(v) => props.onSelect(v)}
          options={props.options}
        />
      </div>
    </div>
  );
};

export default FullPicker;
